import { post, get } from '../config/$ajax'

/**
 * 保存默认列配置
 * 这个由我们前端自己定义,不提供给用户使用，所以只在测试页面调用，用于初始化默认列配置
 * @param {Object} data
 * http://yapi.raycloud.com/project/738/interface/api/71908
 */
export function colsConfig_saveDefault(data) {
    return post('/columnConfig/saveDefault', data, {appJson: true, submitType: 'json'});
}

/**
 * 查询列配置
 * @param {*} data 
 * http://yapi.raycloud.com/project/738/interface/api/71904
 */
export function colsConfig_query(data) {
    return get('/columnConfig/query', data)
}

/**
 * 修改列配置
 * @param {*} data 
 * http://yapi.raycloud.com/project/738/interface/api/71907
 */
export function colsConfig_update(data, options = {}) {
    return post('/columnConfig/update', data, {appJson: true, submitType: 'json', ...options})
}

/**
 * 恢复默认列配置
 * @param {*} data 
 */
export function colsConfig_updateToDefault(data) {
    return get('/columnConfig/updateToDefault', data)
}

